// Load jquery from server if issues with cdn
!window.jQuery && document.write('<script src="/asset/js/jquery.js"><\/script>')